export default {
    account: 'Tài khoản',
    password: 'Mật khẩu',
    organizationName: 'Tên tổ chức',
    organizationAcronym: 'Tên viết tắt',
    fullAddress: 'Địa chỉ',
    houseNumber: 'Số nhà, tên đường',
    street: 'Đường',
    zipCode: 'Zip Code',
    adminAccount: 'Tài khoản admin',
    phoneNumber: 'Số điện thoại',
    organizationType: 'Loại tổ chức',
    expiredDate: 'Thời gian hết hạn',
    organizationBranchName: 'Tên chi nhánh',
    cameraName: 'Tên camera',
    streamUrl: 'Link stream',
    employeeCode: 'Mã nhân viên',
    firstName: 'Tên',
    lastName: 'Họ',
    birthday: 'Ngày sinh',
    type: 'Tên tài sản',
    deviceType: 'Loại tài sản',
    brand: 'Hãng',
    model: 'Mã',
    serialNumber: 'Số Serial',
    totalQuantity: 'Số lượng',
    importDate: 'Ngày nhập',
    supplier: 'Nhà cung cấp',
    fromDate: 'Ngày bắt đầu',
    toDate: 'Ngày kết thúc',
    assignDate: 'Ngày cấp',
    reason: 'Lí do',
    workShiftName: 'Tên ca',
    workDayOfWeek: 'Ngày làm việc',
    startHour: 'Thời gian bắt đầu',
    endHour: 'Thời gian kết thúc',
    bufferTime: 'Thời gian linh động',
    groupName: 'Tên nhóm',
    allowCheckInBefore: 'Cho phép check in trước',
    allowCheckInAfter: 'Cho phép check in sau',
    allowCheckOutBefore: 'Cho phép check out trước',
    allowCheckOutAfter: 'Cho phép check out sau',
    equipmentType: 'Tên vật dụng',
    dailyWorkName: 'Tên công việc',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    dailyWorkDetailName: "Tên vật dụng",
    methodCheck: "Phương pháp",
    completionCriteria: "Yêu cầu công việc",
    placeDetailName: "Tên địa điểm",
    level: "Cấp độ ưu tiên",
    address: "Địa chỉ",
    areaDetailName: "Tên khu vực",
    nameRestrictedarea: "Tên sự kiện",
    fromHour: "Thời gian bắt đầu",
    toHour: "Thời gian kết thúc",
    date: "Ngày khiếu nại chấm công",
    newPassword: "Mật khẩu mới",
    cameraGroupName: "Tên nhóm",
    qrCode: "Mã QR",
    titleNotify: "Nhập tiêu đề",
    abbreviate: "Nhập tóm tắt",
    name: "Tên phòng họp",
    location: 'Địa điểm',
    reservationName: "Tên cuộc họp",
    purpose: "Mục đích",
    dateBegin: "Ngày họp",
    meetingRoom: "Phòng họp",
    participants: 'Người tham dự',
    timeKeepingType: 'Đối tác',
    oldPassWord: 'Mật khẩu cũ',
    newPassWord:'Mật khẩu mới',
    reNewPassWord: 'Nhập lại mật khẩu mới',
    title: 'Tiêu đề',
    typeForNewsEvent: 'Chủ đề',
    email: 'Email',
    userName: 'Tên đăng nhập',
    salary: 'Lương',
    fullName:'Tên đầy đủ',
    rePassword:'Mật khẩu xác nhận',
    wifiName:'Tên Wifi',
    CMT: 'CMT',
    emailModel: 'Email',
    numberPeople: 'Số người',
    camera: 'Camera',
    workshift: 'Ca làm việc',
    streetName: 'Tòa nhà, Tên đường',
    startWork: 'Ngày bắt đầu làm việc',
    employee: 'Nhân viên',

    policyName: 'Tên chính sách',
    policyCode: 'Mã chính sách',
    policyType: 'Loại chính sách',
    annualLeave: 'Số lượng phép chuẩn hàng năm',
    policyContent: 'Nội dung chính sách',
    position: 'Chức vụ',
    branch: 'Chi nhánh',
    codeCustomer: 'Mã khách hàng',
    dayOfBirth: 'Ngày sinh',
    gender: 'Giới tính',
    identityCard: 'Thẻ định danh',
    nameServiceType: 'Tên dịch vụ',
    codeServiceType: 'Mã dịch vụ',
    nameServicePacks: 'Tên chỉ tiêu',
    codeServicePacks: 'Mã chỉ tiêu',
    time: 'Thời gian',
    unit: 'Đơn vị',
    unitPrice: 'Đơn giá',
    departmentName: 'Tên phòng ban',
    codeCombo: 'Mã gói dịch vụ',
    nameCombo: 'Tên gói dịch vụ',
    customer: 'Khách hàng',
    ethnic: 'Dân tộc',
    reply: 'Phản hồi',
    branchType: 'Loại phòng ban',
    sourceType: 'Nguồn khách',
    nameIconApp: 'Tên môi trường',
    urlApp: 'Đường dẫn',
    ordersApp: 'Số thứ tự',
    nameCardClass: 'Tên hạng thẻ',
    cardMilestone: 'Điểm thẻ',
    groupName:'Tên nhóm',
    manager:'Người quản lí',
    employee:'Nhân sự',

    /*Care Module*/
    careDashboad: 'Thống kê chăm sóc',
    careSms: 'SMS chăm sóc',
    careEmail: 'Email chăm sóc',
    /*End Care Module*/
}
